<template>
  <a-button
    :block="!typeLink"
    :class="!typeLink ? 'table-cell__actions-btn' : 'actions-link'"
    :type="typeLink ? 'link' : 'text'"
    :disabled="disabled"
    @click="handleShowModal"
  >
    <template #icon v-if="!typeLink">
      <UserAddOutlined
        :style="{
          fontSize: '16px',
        }"
      />
    </template>

    <a-modal
      :visible="visible"
      centered
      width="750px"
      :keyboard="false"
      :title="titleStrategy"
      :body-style="bodyStyle"
      :mask-closable="false"
      class="modal_strategy"
      @cancel="handleConfirmationClose"
    >
      <div class="modal__body" :class="{ 'modal__body--readonly': readonly }">
        <p v-if="agentsStrategy.length > 0">
          Aquí podrás seleccionar todos los usuarios con permiso disponible para realizar gestiones masivas.
        </p>
        <strategy-profile-check-list :strategy="strategy" v-if="visible && strategy" />
      </div>
      <template #footer>
        <a-button v-if="!readonly" @click="handleConfirmationClose"> Cancelar </a-button>
        <a-tooltip>
          <template
            #title
            v-if="
              (getUsersSelected?.length === 0 && strategy.type_strategy == TypeStrategy.IvrReturn) ||
              !hasChanges  
            "
          >
            <span v-if="getUsersSelected?.length === 0 && strategy.type_strategy == TypeStrategy.IvrReturn">Es necesario que selecciones mínimo 1 usuario.</span>
            <span v-else>No hay nuevos cambios por guardar</span>
          </template>
          <a-button
            v-if="!readonly"
            type="primary"
            :loading="loading"
            :disabled="
              agentsStrategy.length === 0 || 
              (getUsersSelected?.length === 0 && strategy.type_strategy == TypeStrategy.IvrReturn) || 
              !hasChanges ||
              loading
            "
            @click="handleConfirmOk"
          >
            {{ textSave }}
          </a-button>
        </a-tooltip>
        <a-button v-if="readonly" type="primary" @click="handleCloseModal"> Cerrar </a-button>
      </template>
    </a-modal>
    <span v-if="typeLink">
      aquí
    </span>
    <p v-else-if="strategy?.users?.length > 0">
      Editar usuarios
    </p>
    <p v-else>
      Añadir usuarios
    </p>
  </a-button>
</template>

<script>
import { IvrDerivation } from "@/app/strategies/utils/enums";
import { StrategyType } from "@/app/shared/utils/enums";
import { UserAddOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import StrategyProfileCheckList from "@/app/strategies/components/modals/StrategyProfileCheckList.vue";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import { refreshStrategyUsers } from "@/app/shared/services";
import { TypeStrategy } from "@/@types/strategies/modalStrategy";

export default {
  components: {
    UserAddOutlined,
    StrategyProfileCheckList,
  },
  props: {
    strategy: {
      required: true,
      type: Object,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    typeLink: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      bodyStyle: {
        padding: "20px 50px 0",
      },
      agents: [],
      selecteds: [],
      TypeStrategy,
    };
  },
  computed: {
    user() {
      return this.$store.getters["getDataUser"];
    },
    disabled() {
      const isIvr = this.strategy.type_strategy === StrategyType.ivr;
      return isIvr;
    },
    agentsStrategy() {
      return this.$store.getters["getAgentsStrategy"];
    },
    titleStrategy() {
      const modalType =
        this.strategy.users_assigned.length > 0 ? "Editar Usuarios" : "Agregar Usuarios";

      const strategyName = this.strategy.name;

      return `${modalType} - ${strategyName}`;
    },
    textSave() {
      return this.strategy.users_assigned.length > 0 ? "Guardar usuarios" : "Agregar usuarios";
    },
    globalState() {
      return this.$store.getters["getStateUser"];
    },
    newUsersSelected() {
      const idsArray = this.$store.getters["getSelectedActiveUsersId"];

      return [...new Set(idsArray)];
    },
    getUsersSelected() {
      const groupProfiles = this.$store.getters["getProfilesGroupStrategy"];
      const filteredUsers = Object.values(groupProfiles).flat();
      return filteredUsers.filter((user) => user.added).map((user) => user.id);
    },
    hasChanges() {
      return (
        this.strategy?.users?.map((user) => user.id).sort().toString() !==
        this.getUsersSelected.sort().toString()
      );
    }
  },
  methods: {
    async handleOk() {
      try {
        this.loading = true;
        await this.$store.dispatch("addUsersProfileStrategy", {
          strategyId: this.strategy.id,
        });
        // this.$store.dispatch("fetchAllStrategies");
        if (this.strategy?.users?.length === 0) {
          this.$message.success("Usuarios añadidos a la estrategia con éxito");
        } else {
          this.$message.success("Cambios guardados con éxito");
        }
        
      } catch (error) {
        this.$message.error("Ocurrió un error al agregar usuario, intentelo nuevamente");
        console.log(error);
      } finally {
        this.loading = false;
      }

      try {
        const socketData = {
          customer_id: this.user.customer.id,
          turned_on: this.strategy.turned_on,
        };

        await Promise.allSettled(
          this.newUsersSelected?.map((userId) =>
            refreshStrategyUsers({ ...socketData, iduser: userId })
          )
        );
      } catch (error) {
        console.log("No se pudo actualizar el estado de los usuario agregados", error);
      } finally {
        this.handleCloseModal();
      }
    },
    handleConfirmOk() {
      Modal.confirm({
        title: "¿Estás seguro de guardar los cambios?",
        content: "Se guardarán los cambios hechos al listado de los usuarios de la estrategia",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleOk(),
        centered: true,
        okText: "Sí, guardar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCloseModal() {
      this.$store.commit("RESET_NEW_SELECTED_USERS");
      this.visible = false;
    },
    handleConfirmationClose() {
      if (!this.hasChanges) {
        this.handleCloseModal();
        return;
      }
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que, si no guardas los cambios que realizaste, estos serán descartados.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCloseModal(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
  },
};
</script>

<style lang="sass" scoped>
p
  color: $gray-8

.modal
  &__title
    color: $gray-9
    font-weight: 600

  &__body
    color: $gray-9
    margin: 0 auto
    user-select: none

    &--readonly
      & .panel--left
        opacity: 0.5

  &__picker
    margin-bottom: 12px

.panel
  height: 380px
  max-height: 380px
  background-color: white
  border-radius: 2px
  border: $border-normal
  margin: 4px 0 0 0
  padding: 12px

  &--high
    padding: 4px 8px

.field
  padding: 4px 0

.block
  margin-bottom: 12px

  &__item
    font-size: 12px
    display: flex
    align-items: center
    justify-content: space-between
    background-color: $blue-1
    border: 1px solid $blue-3
    border-radius: 2px
    padding: 2px 8px
    margin: 4px 0

  &__icon
    font-size: 10px

.fullname
  margin-left: -90px

.actions-link
  padding: 0

:global(.modal_strategy .ant-tooltip-disabled-compatible-wrapper)
  margin: 0 8px !important
</style>
